<div class="container">
  <mat-form-field appearance="standard" *ngIf="data.limit">
    <mat-label>Límite</mat-label>
    <mat-select [formControl]="limitControl">
      <mat-option [value]="10">10</mat-option>
      <mat-option [value]="25">25</mat-option>
      <mat-option [value]="50">50</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="buttons-container">
    <button
      [disabled]="disabled || data.page <= 1"
      mat-button
      (click)="emitPaginatorEvent(data.page - 1, data.limit)"
    >
      &nbsp;
    </button>
    <p class="current-page">{{ data.page }}</p>
    <button
      [disabled]="disabled || data.page === data.pageLimit"
      mat-button
      class="next"
      (click)="emitPaginatorEvent(data.page + 1, data.limit)"
    >
      &nbsp;
    </button>
  </div>
</div>
